/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.association.definitions.rpc.AssociationDefinitionsRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getOneDirectionForAllDefinitionsRpc = {
  serviceName: 'com.hubspot.association.definitions.rpc.AssociationDefinitionsRpc',
  rpcName: 'getOneDirectionForAllDefinitions',
  auth: 'app',
  fingerprint: '9muD1ifv3hCEJQPayU9qt5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDefinitionsFromObjectTypeRpc = {
  serviceName: 'com.hubspot.association.definitions.rpc.AssociationDefinitionsRpc',
  rpcName: 'getDefinitionsFromObjectType',
  auth: 'app',
  fingerprint: '_IujAkdkQhSEJQPayU9qt5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllBaseUnlabeledDefinitionsRpc = {
  serviceName: 'com.hubspot.association.definitions.rpc.AssociationDefinitionsRpc',
  rpcName: 'getAllBaseUnlabeledDefinitions',
  auth: 'app',
  fingerprint: 'kkZkC1SFge2EJQPayU9qt5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};